import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [{
	path: '/',
	name: '',
	meta: {
		name: "LANGO",
    title: "广州朗国电子科技股份有限公司",
    description: '广州朗国电子科技股份有限公司是一家专注于电子科技领域的高新技术企业，公司总部位于广州市。公司拥有一支高素质的研发团队和先进的生产设备，致力于为客户提供高质量的电子产品和解决方案。公司的主要产品包括智能硬件、物联网设备、通信设备等，广泛应用于智能家居、智慧城市、工业自动化等领域。公司始终坚持“以客户为中心，以质量为生命”的经营理念，以创新为驱动，以技术为核心，以服务为支撑，为客户提供全方位、一站式的电子科技服务。',
    keywords: '朗国科技,朗国,朗国电子,LANGO,朗国官网,朗国科技官网'
	},
	component: () => import('@/views/Index.vue'),
	children: [{
		path: '/',
		name: 'HomePage',
		component: () => import('@/views/HomePage.vue'),
		meta: {
			name: "LANGO",
      title: "朗国科技",
      description: '广州朗国电子科技股份有限公司（简称“朗国科技”）是一家专注于“人工智能&交互设计”系统方案设计的公司，自2013年创立以来，朗国科技逐步聚焦于人工智能算法、远近场无线传输、操作系统深度定制与优化、云服务、交互应用（APP）、智能终端及控制等六大基础技术的深度开发与融合应用，产品涵盖了智慧商显、智能物联、智能电器、远程会议智能终端、智能牧业、物联网模组等领域，销售与服务覆盖了美洲、欧洲、澳洲等海外地区。',
      keywords: '朗国科技,朗国,朗国电子,LANGO,朗国官网,朗国科技官网'
		},
	}, {
		path: '/ProductCenter',
		name: 'ProductCenter',
		component: () => import('@/views/ProductCenter.vue'),
		meta: {
			name: "产品中心",
      title: "产品中心",
      description: '广州朗国电子科技股份有限公司的产品展示、商业显示器、教育一体机、会议一体机、广告机、物联设备、门锁、网关、阵列麦克风等等',
      keywords: '朗国,朗国科技,一体机,教育,会议,阵列麦克风,广告机,商业显示器',
			id: 13
		},
	}, {
		path: '/Dynamic',
		name: 'Dynamic',
		component: () => import('@/views/Dynamic.vue'),
		meta: {
			name: "朗国动态",
      title: "朗国动态",
      description: '广州朗国电子科技股份有限公司的新闻动态、包含诸多业务活动，荣誉，公司重要事情，里程碑事件的信息',
      keywords: '朗国,朗国科技,业务活动,荣誉,公司重要事情,里程碑事件'
		},
	}, {
		path: '/module',
		name: 'module',
		component: () => import('@/views/module.vue'),
		meta: {
			name: "解决方案-各个模板集合",
      title: "解决方案-各个模板集合",
      description: '广州朗国电子科技股份有限公司的技术软硬件产品解决方案，协助各大客户、厂商快速定制自有产品',
      keywords: '朗国,朗国科技,产品解决方案,快速定制'
		},
	}, {
		path: '/Solution',
		name: '',
		component: () => import('@/views/Solution.vue'),
		meta: {
			name: ""
		},
		children: [{
			path: '/',
			name: 'Solution',
			component: () => import('@/views/solution/index.vue'),
			meta: {
				name: "智能交互一体机",
        title: "智能交互一体机",
        description: '广州朗国电子科技股份有限公司的智能交互一体机是一种集成了多种功能的智能设备，它将计算机、显示器、音响、摄像头、触摸屏等多种设备集成在一起，形成一个完整的交互系统。它具有强大的计算能力、丰富的接口和灵活的配置，可以满足各种应用场景的需求。智能交互一体机可以用于教育、医疗、商业、娱乐等多个领域，为用户提供便捷、高效、智能的交互体验。它具有易用性、可扩展性和可定制性，可以满足不同用户的需求。',
        keywords: '朗国,朗国科技,智能交互,一体机,方案介绍',
				id: 1
			},
		}, {
			path: '/Audio',
			name: 'Audio',
			component: () => import('@/views/solution/Audio.vue'),
			meta: {
				name: "智能视频会议音箱",
        title: "智能视频会议音箱",
        description: '广州朗国电子科技股份有限公司的智能视频会议音箱是一种专为远程视频会议设计的智能音箱，它内置了高清晰度的摄像头和麦克风，可以实现高清视频通话和语音通话。智能视频会议音箱还具有智能降噪功能，可以有效地消除背景噪音，提高通话质量。它还可以与其他智能设备联动，实现智能家居控制、音乐播放等功能。智能视频会议音箱具有时尚的外观设计和便捷的操作界面，可以让用户轻松进行远程视频会议和智能生活体验。',
        keywords: '朗国,朗国科技,视频会议,音箱,智能会议',
				id: 3
			},
		}, {
			path: '/Terminal',
			name: 'Terminal',
			component: () => import('@/views/solution/Terminal.vue'),
			meta: {
				name: "视频会议一体机",
        title: "视频会议一体机",
        description: '广州朗国电子科技股份有限公司的视频会议一体机是一种集成了多种功能的智能设备，它将计算机、显示器、音响、摄像头、触摸屏等多种设备集成在一起，形成一个完整的交互系统。它具有强大的计算能力、丰富的接口和灵活的配置，可以满足各种应用场景的需求。视频会议一体机可以用于教育、医疗、商业、娱乐等多个领域，为用户提供便捷、高效、智能的交互体验。它具有易用性、可扩展性和可定制性，可以满足不同用户的需求。视频会议一体机还可以与云平台进行联动，实现远程视频会议、在线教育、远程医疗等功能。',
        keywords: '朗国,朗国科技,视频会议,一体机',
				id: 2
			},
		}, {
			path: '/AIOT',
			name: 'AIOT',
			component: () => import('@/views/solution/AIOT.vue'),
			meta: {
				name: "AIOT系列模组",
        title: "AIOT系列模组",
        description: '广州朗国电子科技股份有限公司的AIOT系列模组是一种集成了多种功能的智能设备，它可以用于各种物联网设备的开发和应用。AIOT系列模组具有强大的计算能力、丰富的接口和灵活的配置，可以满足各种应用场景的需求。它可以用于智能家居、智慧城市、工业自动化等多个领域，为用户提供便捷、高效、智能的物联网服务。AIOT系列模组具有易用性、可扩展性和可定制性，可以满足不同用户的需求。它还可以与云平台进行联动，实现远程监控、数据分析等功能。',
        keywords: '朗国,朗国科技,AIOT,模组',
				id: 10
			},
		}, {
			path: '/advertisement',
			name: 'advertisement',
			component: () => import('@/views/solution/advertisement.vue'),
			meta: {
				name: "广告机硬件解决方案",
        title: "广告机硬件解决方案",
        description: '广州朗国电子科技股份有限公司的广告机硬件解决方案是一种集成了多种功能的智能设备，它可以用于各种广告机的开发和应用。广告机硬件解决方案具有强大的计算能力、丰富的接口和灵活的配置，可以满足各种应用场景的需求。它可以用于商场、机场、地铁站等多个场所，为用户提供便捷、高效、智能的广告服务。广告机硬件解决方案具有易用性、可扩展性和可定制性，可以满足不同用户的需求。它还可以与云平台进行联动，实现远程监控、数据分析等功能。',
        keywords: '朗国,朗国科技,视频会议,一体机',
				id: 5
			},
		}, {
			path: '/gateway',
			name: 'gateway',
			component: () => import('@/views/solution/gateway.vue'),
			meta: {
				name: "智能网关",
        title: "智能网关",
        description: '广州朗国电子科技股份有限公司的智能网关是一种集成了多种功能的智能设备，它可以用于各种物联网设备的联网和管理。智能网关具有强大的计算能力、丰富的接口和灵活的配置，可以满足各种应用场景的需求。它可以用于智能家居、智慧城市、工业自动化等多个领域，为用户提供便捷、高效、智能的物联网服务。智能网关具有易用性、可扩展性和可定制性，可以满足不同用户的需求。它还可以与云平台进行联动，实现远程监控、数据分析等功能。',
        keywords: '朗国,朗国科技,智能网关,一体机',
				id: 14
			},
		}, {
      path: '/Battery',
      name: 'Battery',
      component: () => import('@/views/solution/Battery.vue'),
      meta: {
        name: "移动储能",
        title: "移动储能",
        description: '广州朗国电子科技股份有限公司的移动储能是一种集成了多种功能的智能设备，它可以用于各种应用场景的储能和供电。移动储能具有强大的储能能力、丰富的接口和灵活的配置，可以满足各种应用场景的需求。它可以用于户外活动、应急救援、电力供应等多个领域，为用户提供便捷、高效、智能的储能服务。移动储能具有易用性、可扩展性和可定制性，可以满足不同用户的需求。它还可以与云平台进行联动，实现远程监控、数据分析等功能。',
        keywords: '朗国,朗国科技,储能,电力',
        id: 15
      },
    }, {
			path: '/animalHusbandry',
			name: 'animalHusbandry',
			component: () => import('@/views/solution/animalHusbandry.vue'),
			meta: {
				name: "智能牧业",
        title: "智能牧业",
        description: '广州朗国电子科技股份有限公司的智能牧业是一种利用先进的科技手段对畜牧业进行智能化管理的新型模式。通过使用各种智能设备，如物联网设备、传感器、数据分析等，可以实现对畜牧业生产过程的实时监控和智能化管理，提高畜牧业的生产效率和质量。智能牧业可以应用于各种畜牧业，如牛羊养殖、猪鸡养殖等，为畜牧业的发展提供了新的思路和方向。',
        keywords: '朗国,朗国科技,牧业',
				id: 11
			},
		}, {
			path: '/accessControl',
			name: 'accessControl',
			component: () => import('@/views/solution/accessControl.vue'),
			meta: {
				name: "智能门禁考勤测温解决方案",
        title: "智能门禁",
        description: '广州朗国电子科技股份有限公司的智能门禁是一种先进的高科技防范和管理手段，通过无线网络技术，将门禁系统与计算机网络相连接，实现了门禁系统的远程监控和管理。智能门禁系统可以根据不同的应用场景，设计出不同的功能模块，如开门授权、考勤管理、权限管理等。同时，智能门禁系统还可以实现数据统计、报警处理等功能，大大提高了门禁系统的安全性和管理效率。',
        keywords: '朗国,朗国科技,门禁,考勤',
				id: 4
			},
		}, {
			path: '/breed',
			name: 'breed',
			component: () => import('@/views/solution/breed.vue'),
			meta: {
				name: "智能种殖",
        title: "智能种殖",
        description: '广州朗国电子科技股份有限公司的智能种植是一种利用现代科技手段，实现植物生长过程的自动化和智能化的技术。智能种植系统通常由硬件设备、传感器、控制器等组成，可以实现对植物生长环境的精确控制，如温度、湿度、光照强度等',
        keywords: '朗国,朗国科技,种殖',
				id: 12
			},
		}, {
			path: '/AI',
			name: 'AI',
			component: () => import('@/views/solution/AI.vue'),
			meta: {
				name: "AI主板",
        title: "AI主板",
        description: '广州朗国电子科技股份有限公司的AI主板是基于人工智能技术开发的新型主板，其主要特点是具有高效的计算能力和智能化的功能。AI主板通常采用高性能的处理器和大规模的内存，可以支持各种人工智能算法和应用。同时，AI主板还具有丰富的接口和扩展功能，可以连接各种外部设备和传感器，实现对环境和设备的实时监控和控制。AI主板广泛应用于智能家居、自动驾驶、机器人、无人机等领域，是现代智能设备的核心部件。',
        keywords: '朗国,朗国科技,AI,主板',
				id: 9
			},
		}, {
			path: '/Security',
			name: 'Security',
			component: () => import('@/views/solution/Security.vue'),
			meta: {
				name: "智能安防",
        title: "智能安防",
        description: '广州朗国电子科技股份有限公司的智能安防是一种利用现代科技手段，实现对安全防范和管理的智能化的技术。智能安防系统通常由多种设备和传感器组成，如监控摄像头、门禁系统、报警系统等，可以实现对安全环境的实时监控和管理。智能安防系统可以通过数据分析和人工智能算法，对异常行为和事件进行自动识别和处理，大大提高了安全防范和管理的效率和准确性。智能安防系统广泛应用于各种场所，如住宅、商业、公共设施等，是现代安全防范和管理的重要手段。',
        keywords: '朗国,朗国科技,安防',
				id: 8
			},
		}, {
			path: '/Pay',
			name: 'Pay',
			component: () => import('@/views/solution/Pay.vue'),
			meta: {
				name: "支付解决方案",
        title: "支付解决方案",
				id: 7
			},
		}, {
			path: '/Message',
			name: 'Message',
			component: () => import('@/views/solution/Message.vue'),
			meta: {
				name: "信息发布系统解决方案",
        title: "信息发布系统",
        description: '广州朗国电子科技股份有限公司的信息发布系统是一种高效、便捷的信息传播手段，可以实现对信息的自动化和智能化发布。信息发布系统可以支持多种信息发布设备和软件，如信息发布平台、信息发布设备、信息发布软件等，可以实现对信息的发布、管理、统计等功能。信息发布系统还可以实现信息的精准推送和定向传播，如短信、邮件、推送通知等。信息发布系统广泛应用于各种场合，如商业、政务、媒体、教育等，是现代信息传播的重要手段。',
        keywords: '朗国,朗国科技,信息发布,广告',
				id: 6
			},
		}]
	}, {
		path: '/JoinUs',
		name: 'JoinUs',
		component: () => import('@/views/JoinUs.vue'),
		meta: {
			name: "加入我们"
		},
	}, {
		path: '/AboutUs',
		name: 'AboutUs',
		component: () => import('@/views/AboutUs.vue'),
		meta: {
			name: "关于朗国"
		},
	}, {
		path: '/CampusRecruitment',
		name: 'CampusRecruitment',
		component: () => import('@/views/CampusRecruitment.vue'),
		meta: {
			name: "校园招聘"
		},
	}, {
		path: '/Form',
		name: 'Form',
		component: () => import('@/views/Form.vue'),
		meta: {
			name: "合作咨询表单"
		},
	}, {
		path: '/DownLoad',
		name: 'DownLoad',
		component: () => import('@/views/DownLoad.vue'),
		meta: {
			name: "服务与支持"
		},
	}, {
		path: '/News',
		name: 'News',
		component: () => import('@/views/News.vue'),
		meta: {
			name: "新闻内页"
		},
	}]
}];

let router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes
});
// 解决路由重复点击报错问题；
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
// 路由拦截
router.beforeEach((to, from, next) => {
	this.$debug && console.log('跳转路由=>to', to);
	this.$debug && console.log('跳转路由=>from', from);
	to.meta.keepAlive = Boolean(to.query.keepalive);
	// 更改页面标题
	if (to.meta.name) {
		document.title = to.meta.name
	}
	if(to.meta.description){
    document.head.querySelector('meta[name="description"]').content = to.meta.description
  }else{
    document.head.querySelector('meta[name="description"]').content = ""
  }
  if(to.meta.keywords){
    document.head.querySelector('meta[name="keywords"]').content = to.meta.keywords
  }else{
    document.head.querySelector('meta[name="keywords"]').content = "朗国科技,朗国,LANGO,朗国电子"
  }
	//拦截指定路由
	if (to.path === 'aaa') {

	} else {
		next();
		scrollTo(0, 0); //马上回到顶部
		// 缓慢回到顶部
		// let distance = window.pageYOffset;
		// let step = distance / 10;
		// let distanceY = distance;
		// let tiemr = setInterval(() => {
		// 	distanceY -= step;
		// 	window.scrollTo(0, distanceY);
		// 	if (distanceY <= 0) {
		// 		clearInterval(tiemr);
		// 	}
		// }, 10);
	}
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js